import { MyRequestResponsibility } from 'Js/myScreenComponents/myRequestResponsibility/myRequestResponsibility';

export const myRequestResponsibility = {
  template: require('./myRequestResponsibility.html'),
  controllerAs: 'ctrl',
  controller: MyRequestResponsibility,
};
